import React from 'react';

import LicenseFieldGroup, { LicenseFieldGroupProps } from './LicenseFieldGroup';
import MultiRowInput, { MultiRowInputProps } from '../MultiRowInput';
import { useTranslation } from '@fluentsms/i18n';

export type MultiRowLicenseFieldGroupProps = LicenseFieldGroupProps & Omit<MultiRowInputProps, 'children'>;

export const MultiRowLicenseFieldGroup = ({
  index,
  value,
  onChange,
  onBlur,
  onAdd = () => undefined,
  onRemove = () => undefined,
  disabled = false,
  ...props
}: MultiRowLicenseFieldGroupProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <MultiRowInput
      onAdd={onAdd}
      onRemove={onRemove}
      index={index}
      confirmModalText={t('multiRowLicenseFieldGroup.areYouSure')}
      disableAdd={disabled}
    >
      <LicenseFieldGroup
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
        StateSelectFieldProps={{ disabled: disabled }}
        LicenseFieldProps={{ disabled: disabled }}
      />
    </MultiRowInput>
  );
};

export default MultiRowLicenseFieldGroup;
